// @flow
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { getParam } from 'utils/url';
import type { Location } from 'react-router-dom';
import { connect } from 'react-redux';
import { subscribeToSubsite } from 'api/cms';
import { showModal as showModalAction } from '../redux/main/actions/modal';

const { useState, useEffect, useCallback } = React;

type OwnProps = {
  subsiteId: string,
  render: ({
    subscribe: () => void,
    isSubscribed: boolean,
    submitting: boolean
  }) => React.Node,
  location: Location
};

type Props = {
  ...$Exact<OwnProps>,
  currentUser: Object,
  showModal: typeof showModalAction
};

const SubscribeToSubsiteContainer = ({
  subsiteId,
  render,
  currentUser,
  showModal,
  location
}: Props) => {
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const subscribe = useCallback(
    () => {
      if (currentUser.id) {
        setSubmitting(true);
        subscribeToSubsite(subsiteId).then(() => {
          setIsSubscribed(true);
          setSubmitting(false);
        });
      } else {
        showModal('EMAIL_SIGNUP', {
          subscribedSubsite: subsiteId,
          signupEmailParams: {
            subscribeSubsiteId: subsiteId
          },
          onLogin: () => {
            setIsSubscribed(true);
          }
        });
      }
    },
    [currentUser.id, showModal, subsiteId]
  );

  useEffect(
    () => {
      if (currentUser.isLoaded) {
        const initSubscribe = getParam(location, 'subscribe');
        if (initSubscribe) {
          subscribe();
        }
      }
    },
    [currentUser.isLoaded, location, subscribe]
  );

  return render({
    subscribe,
    isSubscribed,
    submitting
  });
};

const mapStateToProps = ({ currentUser }) => ({ currentUser });

export default withRouter(
  connect(
    mapStateToProps,
    { showModal: showModalAction }
  )(SubscribeToSubsiteContainer)
);
